
<div>
  <b-col cols="12" sm="12">
    <div v-for="(rotation, index) in rotations" :key="index">
      <RotatingSubscription
        :rotation="rotation"
        :subscription="subscription"
        :vendor_uuid="vendor.uuid"
        @view-meals-selection-for-slot="(viewSub) => $emit('view-meals-selection-for-slot', viewSub)"
      />
    </div>
  </b-col>
</div>
